import axios from "axios"
import { URI_LOCAL } from "../data/constants"

export const getAllScenariosById = (id:string) => {
    const response = axios.get(`${URI_LOCAL}Admin_escenario/get_all_scenarios_by_plant_id/${id}`)
    return response
}

export const restoreScenarios = (ids:any) => {
    const response = axios.put(`${URI_LOCAL}Admin_escenario/restore_scenario`,{ids:ids})
    return response
}

export const disableScenarios = (ids:any) => {
    const response = axios.put(`${URI_LOCAL}Admin_escenario/disable_scenario`,{ids:ids})
    return response
}

export const deleteScenarios = (ids:any) => {
    const response = axios.put(`${URI_LOCAL}Admin_escenario/delete_scenario`,{ids:ids})
    return response
}